import React, { useEffect } from "react";
import { createPortal } from "react-dom";

function ConfirmDialog({
    open,
    title = "Xác nhận",
    message,
    confirmText = "Đồng ý",
    cancelText = "Hủy",
    danger = false,
    loading = false,
    onConfirm,
    onCancel,
}) {
    useEffect(() => {
        if (!open) return;
        const onKey = (e) => {
            if (e.key === "Escape" && !loading) onCancel?.();
        };
        window.addEventListener("keydown", onKey);
        const prev = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return () => {
            window.removeEventListener("keydown", onKey);
            document.body.style.overflow = prev;
        };
    }, [open, loading, onCancel]);

    if (!open) return null;

    return createPortal(
        <div
            className="fixed inset-0 z-[200] flex items-center justify-center bg-black/40 p-4"
            onClick={() => !loading && onCancel?.()}
        >
            <div
                className="bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden"
                onClick={(e) => e.stopPropagation()}
                style={{ animation: "fadeIn 0.15s ease-out" }}
            >
                <div className="p-5">
                    <h3 className="text-base font-semibold text-gray-900">{title}</h3>
                    {message && (
                        <p className="mt-2 text-sm text-gray-600 leading-relaxed">
                            {message}
                        </p>
                    )}
                </div>
                <div className="flex items-center justify-end gap-2 px-5 py-3 border-t border-gray-100 bg-gray-50">
                    <button
                        type="button"
                        disabled={loading}
                        onClick={onCancel}
                        className="px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 rounded-lg disabled:opacity-50"
                    >
                        {cancelText}
                    </button>
                    <button
                        type="button"
                        disabled={loading}
                        onClick={onConfirm}
                        className={`px-4 py-2 text-sm font-medium text-white rounded-lg disabled:opacity-50 ${danger
                                ? "bg-red-600 hover:bg-red-700"
                                : "bg-gray-900 hover:bg-gray-800"
                            }`}
                    >
                        {loading ? "Đang xử lý…" : confirmText}
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
}

export default ConfirmDialog;
